import { useViewMode } from './ModeProvider'

export function ModeToggle() {
  const { mode, setMode } = useViewMode()
  return (
    <div
      role="group"
      aria-label="Görünüm tercihi"
      className="hidden md:inline-flex items-center text-[11px] sm:text-xs rounded border border-border bg-surface-2 overflow-hidden"
    >
      <button
        type="button"
        onClick={() => setMode('simple')}
        aria-pressed={mode === 'simple'}
        className={
          mode === 'simple'
            ? 'px-2 py-1 bg-accent text-accent-fg'
            : 'px-2 py-1 text-text-dim hover:text-text'
        }
      >
        Basit
      </button>
      <button
        type="button"
        onClick={() => setMode('advanced')}
        aria-pressed={mode === 'advanced'}
        className={
          mode === 'advanced'
            ? 'px-2 py-1 bg-accent text-accent-fg'
            : 'px-2 py-1 text-text-dim hover:text-text'
        }
      >
        İleri
      </button>
    </div>
  )
}

export function ModeToggleCompact() {
  const { mode, setMode } = useViewMode()
  return (
    <button
      type="button"
      onClick={() => setMode(mode === 'simple' ? 'advanced' : 'simple')}
      className="md:hidden text-[11px] uppercase tracking-wider px-2 py-0.5 rounded border border-border bg-surface-2 text-text-dim hover:text-text whitespace-nowrap"
      title="Görünümü değiştir"
    >
      {mode === 'simple' ? 'Basit' : 'İleri'}
    </button>
  )
}
